var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ExperimentParticipationSentence'),_vm._v(" "),_c('TextLink',{attrs:{"text":"実証実験に参加"},on:{"click-text":_vm.onClickAgree}}),_vm._v(" "),_c('TextLink',{attrs:{"text":"実証実験に参加しない"},on:{"click-text":_vm.onClickNotAgree}}),_vm._v(" "),(_vm.isTest)?_c('p',[_vm._v("テスト版")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-252abbc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/ExperimentParticipationCheck.vue
// module id = null
// module chunks = 